import { apiClient } from '@/lib/api/client';
import type { ApiEnvelope } from '@/types/api';
import type {
  JuthoorInitiative,
  JuthoorInitiativeStatus,
  JuthoorTreePricing,
  JuthoorProfitLedger,
  JuthoorAdminDashboard,
  SetPricingPayload,
} from '@/types/juthoor';

export async function getJuthoorPendingAdminApprovals(params?: {
  page?: number;
  per_page?: number;
}): Promise<ApiEnvelope<JuthoorInitiative[]>> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.per_page) query.set('per_page', String(params.per_page));
  const qs = query.toString();
  return apiClient.get<JuthoorInitiative[]>(
    `/api/admin/v2/juthoor/initiatives/pending${qs ? `?${qs}` : ''}`
  );
}

export async function getJuthoorAdminInitiative(
  id: string
): Promise<ApiEnvelope<JuthoorInitiative>> {
  return apiClient.get<JuthoorInitiative>(`/api/admin/v2/juthoor/initiatives/${id}`);
}

export async function setJuthoorPricing(
  id: string,
  payload: SetPricingPayload
): Promise<ApiEnvelope<JuthoorTreePricing>> {
  return apiClient.post<JuthoorTreePricing>(
    `/api/admin/v2/juthoor/initiatives/${id}/pricing`,
    payload
  );
}

export async function approveJuthoorInitiative(
  id: string
): Promise<ApiEnvelope<{ id: string; status: JuthoorInitiativeStatus; netzero_project_id: number }>> {
  return apiClient.post<{ id: string; status: JuthoorInitiativeStatus; netzero_project_id: number }>(
    `/api/admin/v2/juthoor/initiatives/${id}/approve`,
    {}
  );
}

export async function rejectJuthoorInitiative(
  id: string,
  payload: { reason: string }
): Promise<ApiEnvelope<void>> {
  return apiClient.post<void>(
    `/api/admin/v2/juthoor/initiatives/${id}/reject`,
    payload
  );
}

export async function getJuthoorProfitLedger(
  id: string,
  params?: { page?: number; per_page?: number }
): Promise<ApiEnvelope<JuthoorProfitLedger>> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.per_page) query.set('per_page', String(params.per_page));
  const qs = query.toString();
  return apiClient.get<JuthoorProfitLedger>(
    `/api/admin/v2/juthoor/initiatives/${id}/profit${qs ? `?${qs}` : ''}`
  );
}

export async function getJuthoorAdminDashboard(): Promise<ApiEnvelope<JuthoorAdminDashboard>> {
  return apiClient.get<JuthoorAdminDashboard>('/api/admin/v2/juthoor/dashboard');
}

export async function getJuthoorPricingHistory(params?: {
  page?: number;
  per_page?: number;
}): Promise<ApiEnvelope<JuthoorTreePricing[]>> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.per_page) query.set('per_page', String(params.per_page));
  const qs = query.toString();
  return apiClient.get<JuthoorTreePricing[]>(
    `/api/admin/v2/juthoor/pricing-history${qs ? `?${qs}` : ''}`
  );
}
